import { render, staticRenderFns } from "./CreateAssistant.forth.step.vue?vue&type=template&id=11facc7d&scoped=true&"
import script from "./CreateAssistant.forth.step.vue?vue&type=script&lang=js&"
export * from "./CreateAssistant.forth.step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11facc7d",
  null
  
)

export default component.exports